/**
 * ステータスの分類 取得
 * @param args
 * @returns
 */
export const getRfpClientStatus = (args) => {
    const { isOrder, status } = args;
    // 下書き
    if (status === 'DRAFT') {
        return 'draft';
    }
    // 面談前
    if (status === 'APPLYING' || status === 'NOT_INTERVIEW') {
        return 'notInterview';
    }
    // 未登録
    if (status === 'INTERVIEW') {
        return 'interview';
    }
    // 「発注済」「見送り」
    return isOrder ? 'ordered' : 'sendOff';
};
/**
 * 案件終了 判定
 * @param args
 * @returns
 */
export const getRfpClientIsEnd = (args) => {
    const status = getRfpClientStatus(args);
    // ステータスが「発注済」or「見送り」
    return status === 'ordered' || status === 'sendOff';
};
